import { Route, Routes } from 'react-router';
import AppLayout from '@src/components/AppLayout';
import NotFoundPage from '@src/pages/NotFound.page';
import EditNifOrderPage from './edit.page';
import NewNifOrderPage from './new.page';
import PlaceNifOrderPage from './place-order.page';
import ReuploadIntakePage from './reupload-intake/index.page';
import UploadNifOrderPoaPage from './upload-poa/index.page';

function NifOrderRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="new/*" element={<NewNifOrderPage />} />
      <Route path="edit/:id/*" element={<EditNifOrderPage />} />
      <Route path="reupload-intake/:id/*" element={<ReuploadIntakePage />} />
      <Route path="upload-poa/:id/*" element={<UploadNifOrderPoaPage />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route element={<AppLayout />}>
        <Route path="place-order" element={<PlaceNifOrderPage />} />
      </Route>
    </Routes>
  );
}

export default NifOrderRoutes;
